import { Icon, IconNames, Stack } from '@pairy/pds-react';
import cn from 'classnames';
import { MouseEvent, useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';

import MobilePdfDownloadButton from '../PdfDownloadButton/Mobile';
import MobileShareButton from '../ShareButton/Mobile';
import MobileZoomButton from '../ZoomButton/Mobile';
import MobileLanguageButton from '../LanguageButton/Mobile';
import { isDisableHelpersAtom } from '../../../../../store/index.atom';

import * as Styled from './index.styles';

interface Props {
  fileName: string;
  domain?: string | null;
  isBulk: boolean;
  isDownloadEnabled: boolean;
  ctaFormPage?: number;
  translateKoToEn: (item: string) => string;
  isRedirectCtaFormAppropriate?: boolean;
  isMobileLandscape: boolean;
}

const MobileViewerLayer = ({
  fileName,
  domain,
  isBulk,
  isDownloadEnabled,
  ctaFormPage,
  translateKoToEn,
  isRedirectCtaFormAppropriate,
  isMobileLandscape,
}: Props) => {
  const isHepersDisabled = useAtomValue(isDisableHelpersAtom);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    setIsDrawerOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isHepersDisabled) {
      setIsDrawerOpen(false);
    }
  }, [isHepersDisabled]);

  const mappingCaretIcon = {
    landscape: {
      open: 'ph:caret-right',
      close: 'ph:caret-left',
    },
    default: {
      open: 'ph:caret-down',
      close: 'ph:caret-up',
    },
  };

  const drawerVariantsMap = {
    landscape: {
      open: { width: 'auto' },
      closed: { width: 0 },
    },
    default: {
      open: { height: 'auto' },
      closed: { height: 0 },
    },
  };

  const caretIcon = isMobileLandscape
    ? mappingCaretIcon.landscape
    : mappingCaretIcon.default;

  const drawerVariants = isMobileLandscape
    ? drawerVariantsMap.landscape
    : drawerVariantsMap.default;

  const initialMotion = isMobileLandscape ? { width: 0 } : { height: 0 };

  return (
    <Styled.PositionWrapper
      gap={16}
      justifyContent="flex-end"
      isMobileLandscape={isMobileLandscape}
    >
      <Stack
        gap={isDrawerOpen ? 8 : 0}
        direction={isMobileLandscape ? 'row' : 'column'}
      >
        <Styled.ArrowButton
          className={cn({
            disable: isHepersDisabled,
            backgroundOpacity: isMobileLandscape && !isDrawerOpen,
          })}
          variant="zinc_300"
          radius={9999}
          leftIcon={
            <Icon
              icon={
                isDrawerOpen
                  ? (caretIcon.open as IconNames)
                  : (caretIcon.close as IconNames)
              }
              size={19}
              color="black"
            />
          }
          onClick={toggleDrawer}
          innerStyle={{
            backgroundColor:
              isMobileLandscape && !isDrawerOpen ? 'transparent' : '',
          }}
        />
        <Styled.MotionDiv
          isFlexRow={isMobileLandscape}
          initial={initialMotion}
          animate={isDrawerOpen ? drawerVariants.open : drawerVariants.closed}
          transition={{ duration: 0.15 }}
        >
          {!isHepersDisabled && isDrawerOpen && (
            <>
              <MobilePdfDownloadButton
                fileName={fileName}
                isBulk={isBulk}
                isDownloadEnabled={isDownloadEnabled}
                ctaFormPage={ctaFormPage}
                translateKoToEn={translateKoToEn}
                isRedirectCtaFormAppropriate={isRedirectCtaFormAppropriate}
              />
              <MobileShareButton
                domain={domain}
                fileName={fileName}
                translateKoToEn={translateKoToEn}
                isBulk={isBulk}
              />
              <MobileZoomButton isMobileLandscape={isMobileLandscape} />
              <MobileLanguageButton />
              {/*<V1EntryPill translateKoToEn={translateKoToEn} />*/}
            </>
          )}
        </Styled.MotionDiv>
      </Stack>
    </Styled.PositionWrapper>
  );
};

export default MobileViewerLayer;
